'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var close = require('./close-40bc5458.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
var device_styles = require('./device.styles-facac80d.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var ReactDOM = _interopDefault(require('react-dom'));
var modal$1 = require('./modal-61e0272d.js');
var useWindowDimensions_hook = require('./useWindowDimensions.hook-e1e5a62f.js');

var AdaptiveModalPortal = function (_a) {
    var children = _a.children;
    var modalRoot = document.getElementById('modal-root');
    if (!modalRoot) {
        return null;
    }
    return ReactDOM.createPortal(children, modalRoot);
};

var StyledModal = styled__default(modal$1.Modal)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  overflow: auto;\n\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 100%;\n    height: 100%;\n    max-width: 984px;\n    max-height: 528px;\n    padding: 24px 56px;\n\n    ", "\n\n    ", "\n  }\n"], ["\n  overflow: auto;\n\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 100%;\n    height: 100%;\n    max-width: 984px;\n    max-height: 528px;\n    padding: 24px 56px;\n\n    ",
    "\n\n    ",
    "\n  }\n"])), function (_a) {
    var variant = _a.variant;
    return variant === 'normal'
        && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n        padding: 32px;\n      "], ["\n        padding: 32px;\n      "])));
}, device_styles.mediaMaxWidth(styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n\n      padding: 16px;\n      max-height: none;\n    "], ["\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n\n      padding: 16px;\n      max-height: none;\n    "])))));
var StyledMobileModal = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: ", ";\n\n  padding: 16px;\n  max-height: none;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: ", ";\n\n  padding: 16px;\n  max-height: none;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var CloseIcon = styled__default(close.Close)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  cursor: pointer;\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  cursor: pointer;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var CloseButton = styled__default(button.Button)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: 12px;\n  right: 0px;\n  padding: 0px 16px;\n  cursor: pointer;\n  font-size: 16px;\n  color: ", ";\n\n  &:hover, &:focus {\n    color: ", ";\n"], ["\n  position: absolute;\n  top: 12px;\n  right: 0px;\n  padding: 0px 16px;\n  cursor: pointer;\n  font-size: 16px;\n  color: ", ";\n\n  &:hover, &:focus {\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedMediumGrey;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var MobileModal = function (_a) {
    var children = _a.children, handleClose = _a.onClose, hideMobileCloseButton = _a.hideMobileCloseButton, closeButtonCopy = _a.closeButtonCopy;
    return (React__default.createElement(StyledMobileModal, { "data-testid": "mobile-modal-window", "data-cy": "modal-window" },
        children,
        closeButtonCopy
            ? !hideMobileCloseButton && (React__default.createElement(CloseButton, { text: closeButtonCopy, variant: "link", role: "button", onClick: handleClose, dataCy: "close-icon", "data-testid": "modal-window-close" }))
            : !hideMobileCloseButton && (React__default.createElement(CloseIcon, { size: "xs", variant: "adminBlack", role: "button", onClick: handleClose, dataCy: "close-icon", "data-testid": "modal-window-close" }))));
};
MobileModal.defaultProps = {
    onClose: null,
    hideMobileCloseButton: false,
    closeButtonCopy: null,
};

var maxWidthVariants = {
    normal: 624,
    wide: 984,
};
var AdaptiveModal = function (_a) {
    var children = _a.children, handleClose = _a.onClose, hideMobileCloseButton = _a.hideMobileCloseButton, _b = _a.variant, variant = _b === void 0 ? 'wide' : _b, closeButtonCopy = _a.closeButtonCopy, withCloseButton = _a.withCloseButton;
    var isSmallViewport = useWindowDimensions_hook.useIsSmallViewportWidth();
    return (React__default.createElement(AdaptiveModalPortal, null, isSmallViewport ? (React__default.createElement(MobileModal, { onClose: handleClose, hideMobileCloseButton: hideMobileCloseButton, closeButtonCopy: closeButtonCopy }, children)) : (React__default.createElement(StyledModal, { opened: true, maxWidth: maxWidthVariants[variant], onClose: handleClose, dataTestId: "modal-window", "data-cy": "modal-window", withExitButton: withCloseButton }, children))));
};
AdaptiveModal.defaultProps = {
    onClose: null,
    hideMobileCloseButton: false,
    variant: 'normal',
    closeButtonCopy: null,
    withCloseButton: true,
};

exports.AdaptiveModal = AdaptiveModal;
